<section class="sub-header">
    <!-- Show the back btn -->
    <button class="btn btn-back" (click)="location.back()">Back</button>
    <!-- Show the title -->
    <h2>Upload a Manual Illustration Request</h2>
  </section>
  
  <section class="card mb-3 upload-box">
    <div class="card-body">
      <div class="line-of-2">
        
        <form [formGroup]="illustrationForm" class="illustration-form">

          <div class="form-group required" id="searchCountryName">
            <label for="Country">Country</label>
            <section class="d-flex filter-box mb-3 custom-filter">
              <input type="text" autocomplete="off" class="form-control" id="Country" required #searchCountryField formControlName="Country">
              <ul *ngIf="selectedCountry || filteredCountries.length > 0">
                <li *ngFor="let cty of filteredCountries" (click)="selectCountry(cty)">
                  <p> {{ cty.name }}</p>
                </li>
              </ul>
              <small *ngIf="searchingCountry" class="form-text text-muted">searching...</small>
            </section>
          </div>

          <div [hidden]="!isUSA" class="form-group required">
            
            <section  class="d-flex filter-box mb-3 custom-filter" id="searchCountyName">
              <label for="State">State</label>
              <input type="text" autocomplete="off" class="form-control" id="State" #searchCountyField formControlName="State">
              <ul *ngIf="filteredCounties.length > 0">
                <li *ngFor="let cty of filteredCounties" (click)="selectCounty(cty)">
                  <p> {{ cty.name }}</p>
                </li>
              </ul>
              <small *ngIf="searchingCounty" class="form-text text-muted">searching...</small>
            </section>
          </div>

          <div  class="form-group required" id="searchClientName">
            <label for="ClientName">Client Name</label>
            <section class="d-flex filter-box custom-filter">
                <input type="text" autocomplete="off" placeholder="Search for a client name" required class="form-control" #searchClientField formControlName="ClientName">                    
                <ul *ngIf="!searchingClient">
                  <li *ngIf="!selectedClient && illustrationForm.controls.ClientName.value != '' && !newClient && !searchingClient" (click)="selectClient(null)"><p>The client I search for is not found?</p></li>
                  <li *ngFor="let client of filteredClients" (click)="selectClient(client)">
                    <p> {{ client.accountName }}</p>
                  </li>
                </ul>
                <!-- <small *ngIf="searchingClient" class="form-text text-muted">searching...</small> -->
                <div *ngIf="searchingClient" class="mt-2 searching-spinner">
                  <div class="spinner-border spinner-border-sm mr-1" role="status">
                  </div>
                  <span>Searching...</span>
                </div>
            </section>
            <p><small>Please type part of the client's headquarters/parent name to search for the client. If nothing is found, please type the full HQ client's name (not the subsidiary name here).</small></p>
          </div>

          <div class="form-group" id="regionalDirector">
            <label for="regionalDirector">Regional director</label>
            <section class="d-flex filter-box mb-3 custom-filter">
              <input disabled type="text" class="form-control" id="regionalDirector" formControlName="RegionalDirector">
            </section>
          </div>

          <div class="form-group" id="accountRepresentative">
            <label for="accountRepresentative">Account representative</label>
            <section class="d-flex filter-box mb-3 custom-filter">
              <input disabled type="text" class="form-control" id="accountRepresentative" formControlName="AccountRepresentative">
            </section>
          </div>

      </form>
        
        
      </div>
    </div>
  </section>

  <div *ngIf="illustrationForm.controls.ClientName.value != ''">
    <h3>
      <span>Existing illustrations:</span>
    </h3>

    <div *ngIf="!illustrations || illustrations.length == 0">
      no illustrations for this client
    </div>
    

    <div *ngIf="illustrations.length > 0" class="card-table">
       <a *ngFor="let illustration of illustrations" class="card" [routerLink]="['/illustrations', illustration.id]">
          <div class="card-body">
              <h3>
                  {{ illustration.clientName }}
                  <span *ngIf="illustration.countries[0]?.name">-</span>
                  {{ illustration.countries[0]?.name | titlecase }}
              </h3>
              <h4>
                {{ illustration.illustrationRevisions[0]?.finalizedSupportDate | date }}
              </h4>
              <h4 style="color: lightgray">
                {{ illustration.networkMember?.accountName }}
              </h4>
         </div>
       </a>
    </div>
  </div>


  <div>
    <button (click)="save()" [disabled]="illustrationForm.invalid || !selectedClient || !selectedCountry" class="btn btn-primary d-inline mt-3 mb-5" style="float: right" type="button">
      <span *ngIf="sendingRequest" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
        Create a new Illustration
    </button>
 </div>
 <div *ngIf="showDiscussion" class="mt-5">
  <app-comment-list (sendNewTask)="sendRequestBySendingComment($event)"  [networkMemberId]="networkMemberId" customProcessId="illustration-request"
  [isTagSystemApplicable]="false" [taskId]="requestIllustration.id" [clientName]="requestIllustration.ClientName" [onCreatingNewTask]="true"  ></app-comment-list>
 </div>
 
  
   
    

  